import { useEffect, useState } from 'react';
import { capitalize, sanitizeSpecChars } from '../../../util/text';
import { resolveBreedsSlug } from '../../../util/urlHelpers';

export const useSeoBreed = ({ pbBreed }) => {
    const [breed, setBreed] = useState('');

    useEffect(() => {
        if (!pbBreed) return;

        const seoBreed = sanitizeSpecChars(resolveBreedsSlug(pbBreed))
            .split(' ')
            .map(capitalize)
            .join(' ');

        setBreed(seoBreed);
    }, [pbBreed]);

    return [breed, setBreed];
};
